import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import CompanyUserInviteID from '@/App/CompanyUserInvite/Entity/CompanyUserInviteID'

export default class CompanyUserInvite {
    constructor(
        public readonly id: CompanyUserInviteID,
        public readonly companyUserEmail: string,
        public readonly createdAt: string,
    ) {
        ensureNoUndefinedProperties(this)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: any): CompanyUserInvite {
        return new CompanyUserInvite(
            new CompanyUserInviteID(entityData.id),
            entityData.companyUserEmail,
            entityData.createdAt,
        )
    }

    static hydrateMultiple(entitiesData: any[]): CompanyUserInvite[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
